import { supabase } from "./supabase";

export const STORAGE_REFERENCE_PREFIX = "storage://";

export function buildStorageReference(bucket, path) {
  if (!bucket || !path) return "";
  return `${STORAGE_REFERENCE_PREFIX}${bucket}/${String(path).replace(/^\/+/, "")}`;
}

export function parseStorageReference(reference) {
  const value = String(reference || "").trim();

  if (!value.startsWith(STORAGE_REFERENCE_PREFIX)) {
    return null;
  }

  const withoutPrefix = value.slice(STORAGE_REFERENCE_PREFIX.length);
  const slashIndex = withoutPrefix.indexOf("/");

  if (slashIndex <= 0) {
    return null;
  }

  return {
    bucket: withoutPrefix.slice(0, slashIndex),
    path: withoutPrefix.slice(slashIndex + 1),
  };
}

export async function resolveStorageReference(reference, expiresIn = 3600) {
  const value = String(reference || "").trim();

  if (!value) {
    return "";
  }

  const parsed = parseStorageReference(value);
  if (!parsed) {
    return value;
  }

  if (!supabase) {
    return "";
  }

  const { data, error } = await supabase.storage.from(parsed.bucket).createSignedUrl(parsed.path, expiresIn);

  if (error) {
    console.error("Error resolving storage reference:", error);
    return "";
  }

  return data?.signedUrl || "";
}